import { Component, OnInit, Output, Input } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  @Output('menuToggle') menuToggle: Subject<boolean> = new Subject<boolean>();
  @Input('title') title: string;
  public loggedIn: Observable<boolean>;
  constructor(private authService: AuthenticationService) {
    this.loggedIn = this.authService.loggedIn;

    this.loggedIn.subscribe(res=>{
      // console.log(res);
    })
  }

  ngOnInit() {
  }

  toggleMenu(){
    this.menuToggle.next(true);
  }
}
